/**
 * @file Identity Avatar container.
 */

import { connect } from 'react-redux';

import IdentityAvatar from '../../../components/global/identity/IdentityAvatar';
import {
  getUploadedPhotoByIdentity,
  getUploadedPhotoById,
} from '../../../util/photo-upload';

const mapStateToProps = ({ photoUploads }, ownProps) => ({
  uploadedPhoto:
    getUploadedPhotoByIdentity(photoUploads.photos, ownProps.identity) ||
    // The photo might not be uploaded with the identityId, so try to get it
    // by ID if available.
    getUploadedPhotoById(
      photoUploads.photos,
      ownProps.identity?.current_photo?.id ||
        ownProps.identity?.current_matching_photo?.id,
    ) ||
    // If all else fails, fall back to a passed uploadedPhoto, if any.
    ownProps.uploadedPhoto,
});

export default connect(mapStateToProps)(IdentityAvatar);
